// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 700.98px) {
  body {
    background-color: rgb(22, 0, 100);
  }
  .bg-white my-5 mx-auto {
    background-color: rgb(46, 21, 21);
  }
  .card {
    background: linear-gradient(to bottom, #172cf0, #000530);
  }
  .text_labels {
    color: white;
    margin-top: 0;
  }
  .input_element {
    margin-bottom: 0;
  }
  .ext-white-50 mb-3 {
    justify-content: center;
    align-items: center;
  }
  .btnLogin {
    background: linear-gradient(180deg, rgb(74, 128, 255) 0%, rgb(0, 44, 139) 77%, rgb(48, 145, 248) 100%);
    color: #eaecee;
    font-family: "Saira", "Lucida Console", "Courier New", "monospace";
    font-size: 14pt;
  }
  .text_login {
    color: white;
    margin-top: 0;
  }
}
@media (max-width: 700.97px) {
  body {
    background-color: rgb(22, 0, 100);
  }
  .bg-white my-5 mx-auto {
    background-color: rgb(46, 21, 21);
  }
  .card {
    background: linear-gradient(to bottom, #172cf0, #000530);
  }
  .text_labels {
    color: white;
    margin-top: 0;
  }
  .input_element {
    margin-bottom: 0;
  }
  .ext-white-50 mb-3 {
    justify-content: center;
    align-items: center;
  }
  .btnLogin {
    background: linear-gradient(180deg, rgb(74, 128, 255) 0%, rgb(0, 44, 139) 77%, rgb(48, 145, 248) 100%);
    color: #eaecee;
    font-family: "Saira", "Lucida Console", "Courier New", "monospace";
    font-size: 14pt;
  }
  .text_login {
    color: white;
    margin-top: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/login.scss"],"names":[],"mappings":"AAAA;EACE;IACE,iCAAA;EACF;EAEA;IACE,iCAAA;EAAF;EAGA;IACE,wDAAA;EADF;EAMA;IACE,YAAA;IACA,aAAA;EAJF;EAOA;IACE,gBAAA;EALF;EAQA;IACE,uBAAA;IACA,mBAAA;EANF;EASA;IACE,sGAAA;IACA,cAAA;IACA,kEAAA;IACA,eAAA;EAPF;EAUA;IACE,YAAA;IACA,aAAA;EARF;AACF;AAYA;EACE;IACE,iCAAA;EAVF;EAaA;IACE,iCAAA;EAXF;EAcA;IACE,wDAAA;EAZF;EAiBA;IACE,YAAA;IACA,aAAA;EAfF;EAkBA;IACE,gBAAA;EAhBF;EAmBA;IACE,uBAAA;IACA,mBAAA;EAjBF;EAoBA;IACE,sGAAA;IACA,cAAA;IACA,kEAAA;IACA,eAAA;EAlBF;EAqBA;IACE,YAAA;IACA,aAAA;EAnBF;AACF","sourcesContent":["@media (min-width: 700.98px) {\n  body {\n    background-color: rgb(22, 0, 100);\n  }\n  \n  .bg-white my-5 mx-auto{\n    background-color: rgb(46, 21, 21)\n  }\n  \n  .card{\n    background: linear-gradient(to bottom, #172cf0, #000530);\n  }\n  \n  \n  \n  .text_labels{\n    color: white;\n    margin-top: 0;\n  }\n  \n  .input_element{\n    margin-bottom: 0;\n  }\n  \n  .ext-white-50 mb-3{\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .btnLogin{\n    background: linear-gradient(180deg, rgb(74, 128, 255) 0%, rgb(0, 44, 139) 77%, rgb(48, 145, 248) 100%);\n    color: #eaecee;\n    font-family: \"Saira\", \"Lucida Console\", \"Courier New\", \"monospace\";;\n    font-size: 14pt;\n  }\n\n  .text_login{\n    color: white;\n    margin-top: 0;\n  }\n}\n\n\n@media (max-width: 700.97px) { \n  body {\n    background-color: rgb(22, 0, 100);\n  }\n  \n  .bg-white my-5 mx-auto{\n    background-color: rgb(46, 21, 21)\n  }\n  \n  .card{\n    background: linear-gradient(to bottom, #172cf0, #000530);\n  }\n  \n  \n  \n  .text_labels{\n    color: white;\n    margin-top: 0;\n  }\n  \n  .input_element{\n    margin-bottom: 0;\n  }\n  \n  .ext-white-50 mb-3{\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .btnLogin{\n    background: linear-gradient(180deg, rgb(74, 128, 255) 0%, rgb(0, 44, 139) 77%, rgb(48, 145, 248) 100%);\n    color: #eaecee;\n    font-family: \"Saira\", \"Lucida Console\", \"Courier New\", \"monospace\";\n    font-size: 14pt;\n  }\n\n  .text_login{\n    color: white;\n    margin-top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
